export default __webpack_public_path__ + "static/media/food.9e39ad0d.jpg";